import React from "react";
import { Line } from "react-chartjs-2";

function ScoreBox({ point }) {
  const pointCount = point.length;
  let a = 0;
  let labelForData = new Array(pointCount).fill().map(() => a++);

  const options = {
    legend: false,
    tooltips: {
      enabled: false,
    },

    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  const chartData = {
    labels: labelForData,
    datasets: [
      {
        label: "Points",
        data: point,
        backgroundColor: "rgb(181, 136, 99)",
        pointRadius: 0,
        lineTension: 0.2,
      },
    ],
  };

  return (
    <div className="container-fluid">
      <Line data={chartData} options={options} />
    </div>
  );
}

export default ScoreBox;
